import Paragraph from "../Paragraph/Paragraph";
import './FeatureBlock.scss'

interface IProps {
    content: {
        image: string,
        imagePosition: 'left' | 'right' | string,
        header: string,
        description: string
    }
}

const FeatureBlock: React.FC<IProps> = (props: IProps) => {
    return (
        <div className={'row' + (props.content.imagePosition === 'left' ? ' direction-rtl' : '') }>
            <div className="col-12 col-md-6 col-lg-5 d-flex align-items-center">
                <div className="d-flex">
                <Paragraph
                    content={{
                        header: props.content.header,
                        description: props.content.description
                    }}
                />
                </div>
            </div>
            <div className="col-12 col-md-6 col-lg-7 my-auto text-center pt-4 pt-md-0 image-wrapper">
                <img className={'img-fluid rounded ' + (props.content.imagePosition === 'left' ? 'float-left' : 'float-right') } src={props.content.image} alt="" />
            </div>
        </div>

    );
};

export default FeatureBlock;
